// // src/admindashboardutils/components/ConversionGauge.jsx
// import React from "react";
import GaugeChart from "react-gauge-chart";

// const ConversionGauge = ({ conversionData }) => {
//     const percentage = (conversionData * 100).toFixed(2);
//   <div className="bg-white rounded-lg p-4 shadow-md">
//     <h3 className="text-lg font-medium text-gray-700 mb-4">Conversion %</h3>
//     {console.log("ConversionGauge received conversionData:", conversionData)}
//     <div className="flex justify-center items-center">
//       <GaugeChart
//         id="conversion-gauge"
//         nrOfLevels={20}
//         percent={conversionData}
//         textColor="#000000"
//         needleColor="#345243"
//         needleBaseColor="#345243"
//         colors={["#FF4500", "#FFA500"]}
//         arcWidth={0.3}
//         arcPadding={0.02}
//         cornerRadius={3}
//         // formatTextValue={(value) => `${(value * 100).toFixed(2)}%`}
//         // style={{ width: "350px", height: "200px" }}
//         // textStyle={{ fontSize: "24px", fontWeight: "bold" }}



//      formatTextValue={() => ""} // Hide default text
//           style={{ width: "350px", height: "200px" }}
//         />
//         <span className="absolute text-3xl font-bold" style={{ top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>{`${percentage}%`}</span>
//     </div>
//   </div>
// };




const ConversionGauge = ({ conversionData }) => {
    const percentage = (conversionData * 100).toFixed(2);
    return (
      <div className="bg-white rounded-lg p-4 shadow-md relative">
        <h3 className="text-lg font-medium text-gray-700 mb-4">Conversion %</h3>
        <div className="flex justify-center items-center">
          <GaugeChart
            id="conversion-gauge"
            nrOfLevels={20}
            percent={conversionData}
            textColor="#000000"
            needleColor="#345243"
            needleBaseColor="#345243"
            colors={["#FF4500", "#FFA500"]}
            arcWidth={0.3}
            arcPadding={0.02}
            cornerRadius={3}
            formatTextValue={() => ""} // Hide the default text
            style={{ width: "350px", height: "200px" }}
          />
          <span className="absolute text-3xl font-bold" style={{ top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>{`${percentage}%`}</span>
        </div>
      </div>
    );
  };


  export default ConversionGauge;